import { Component, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ApplicationGroupWithApplicationDatastreams, SiteState } from '../../shared/models';
import * as actions from '../../store/actions';
import {
  selectApplications,
  selectSelectedApplicationGroups,
  selectUnselectedApplicationGroups,
  hasUnselectedApplicationGroups,
  selectDatastreams,
} from '../../store/selectors';

@Component({
  selector: 'app-authorizations',
  templateUrl: './authorizations.component.html',
  standalone: false,
})
export class AuthorizationsComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  applications$ = this.store.pipe(select(selectApplications));
  hasUnselectedApplicationGroups$ = this.store.pipe(select(hasUnselectedApplicationGroups));
  selectedApplicationGroups$ = this.store.pipe(select(selectSelectedApplicationGroups));
  unselectedApplicationGroups$ = this.store.pipe(select(selectUnselectedApplicationGroups));
  datastreams$ = this.store.pipe(select(selectDatastreams));

  openApplicationGroupDialog(): void {
    this.store.dispatch(actions.selectApplicationGroups());
  }

  deleteGroupDatastreams(group: ApplicationGroupWithApplicationDatastreams) {
    this.store.dispatch(actions.deleteGroupDatastreams({ group }));
  }

  setApplicationDatastream(
    applicationKey: string,
    oldDataStreamKeys: string[],
    dataStreamKeys: string[],
  ) {
    this.store.dispatch(
      actions.updateApplicationDatastream({ applicationKey, dataStreamKeys, oldDataStreamKeys }),
    );
  }
}
